import { produce } from 'immer';

import { ResetImportWizard } from '../../actions/importWizard/resetImportWizard';
import { ImportWizardState } from '../../typings/importWizard';

import { getImportWizardInitialState } from './index';

export function resetImportWizard(state: ImportWizardState, action: ResetImportWizard): ImportWizardState {
    return produce(state, draft => {
        Object.assign(draft, getImportWizardInitialState());

        draft.importFile = undefined;
        draft.importData = undefined;
        draft.errors = [];
    });
}
